import { LEAVES_REQUESTS, LeavesServicePath } from "utils/constants";
import RequestsList from "./List";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <NoteAddIcon />,
  name: LeavesServicePath + LEAVES_REQUESTS,
  title: "Заявка за отсъствие",
  list: <RequestsList />,
  permission: permissions.canCreateLeaveRequests,
};
